import { existingHeaders } from "./utils";
import { getSendOtpCodeLink } from "utils/urls";

export const otpService = {
  requestOtp,
  requestForgotPasswordOtp,
  requestAccountRecoveryOtp,
  verifyOtp,
};

const requestOptions = {
  credentials: "same-origin",
  headers: existingHeaders,
  method: "POST",
};

function requestOtp() {
  return fetch(getSendOtpCodeLink(), requestOptions);
}

function requestForgotPasswordOtp(email, recaptchaToken) {
  return fetch("/password/forgotten-password", {
    ...requestOptions,
    body: JSON.stringify(email, recaptchaToken),
  });
}

function requestAccountRecoveryOtp(email, lastName) {
  return fetch("/password/send-otp", {
    ...requestOptions,
    body: JSON.stringify({ email, lastName }),
  });
}

function verifyOtp(code, email, ioBlackbox) {
  return fetch("/password/verify-otp", {
    ...requestOptions,
    method: "PUT",
    body: JSON.stringify({ code, email, ioBlackbox }),
  });
}
